import store from 'store';
import Component from '../component/Component';
class Page extends Component {
    static pageName = 'Page';
    pageManager;
    state = { shown: false, prepared: false, hidden: false };
    pageName() { return this.constructor.pageName || this.constructor.name || true; }
    constructor(el, options, pageManager) {
        super(el, options);
        this.pageManager = pageManager;
    }
    shouldRouteInternally;
    internalRouting;
    initialized() {
        super.initialized();
        if (this.pageManager) {
            const { category, subcategory } = this.el.dataset;
            store.category.set(category || null);
            store.subcategory.set(subcategory || null);
        }
    }
    injectScripts() {
        const scripts = [...this.el.querySelectorAll('script[data-inject]')];
        scripts.forEach(script => {
            if (!script.src) {
                const s2 = document.createElement('script');
                s2.type = 'text/javascript';
                if (script.innerHTML)
                    s2.appendChild(document.createTextNode(script.innerHTML));
                script.parentNode.replaceChild(s2, script);
            }
        });
    }
    bindModules() {
        super.bindModules();
    }
    getModulesMap() {
        return {};
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            pageManager: this.pageManager || this.options?.parent?.pageManager
        };
    }
    /* PREPARE */
    async askPreload(previousPage) {
        if (previousPage)
            this.injectScripts();
        this.el.classList.add('preloading');
        await this.preload(previousPage);
        this.state.prepared = true;
    }
    async preload(previousPage) {
        // await this.preloadImages()
    }
    /* LOAD IMAGES */
    async preloadImages() {
        const imagesToLoad = this.getImagesToLoad();
        if (!imagesToLoad || !imagesToLoad.length)
            return;
        return Promise.all(imagesToLoad.map((v, k) => this.loadImage(v, k, imagesToLoad.length)));
    }
    getImagesToLoad() {
        return Array.from(this.el.querySelectorAll('img:not([loading=lazy])[src]'));
    }
    loadImage(img, i, total) {
        if (~img.src.indexOf('svg'))
            return Promise.resolve();
        return new Promise(resolve => {
            if (img.naturalWidth !== 0 || img.complete)
                return resolve(img);
            img.onerror = img.onload = () => {
                img.onerror = img.onload = null;
                resolve(img);
            };
            img.src = img.currentSrc || img.src; // eslint-disable-line
        });
    }
    /* SHOW */
    async askShow(previousPage, previousEl) {
        this.el.classList.remove('preloading');
        await this.show(previousPage, previousEl);
        this.state.shown = true;
    }
    async show(previousPage, previousEl) {
        this.el.style.opacity = '1';
        this.invoke('show');
    }
    transitionComplete() {
        this.invoke('transitionComplete');
    }
    /* HIDE */
    async askHide(nextPage, nextEl) {
        this.invoke('hide');
        await this.hide(nextPage, nextEl);
        this.state.hidden = true;
    }
    async hide(nextPage, nextEl) {
        this.el.style.opacity = '0';
    }
    resize() {
        this.invoke('resize');
    }
    flush() {
        this.invoke('flush');
        super.flush();
    }
}
export default Page;
